import { TextCell } from '@common/components/TextCell';

interface DepositAmountCellProps {
	/** Formatted currency amount */
	amount?: string;
}

export const DepositAmountCell = ({ amount }: DepositAmountCellProps) => {
	return <TextCell value={amount} weight='semibold' />;
};
